export const DONT_ASK = 'dontAsk';
export const OPTIONAL = 'optional';
export const MANDATORY = 'mandatory';

export const ON_ARRIVAL = 'onArrival';
export const CARD = 'card';
export const INVOICE = 'invoice';
export const SWISH = 'swish';
